import React from 'react';
import PropTypes from 'prop-types';
import useDateFilterType from '../../utils/useDateFilterType';
import DatePicker from '../../../DatePicker';
import DateBetweenFilter from '../DateBetweenFilter';
import DateOptions from '../../../DateOptions';
import RelativeDateFilter from '../RelativeDateFilter';
import dayjs from 'dayjs';

const DateFilter = ({ onChange, operator, settings, suggestions, value, ...props }) => {
  const { margin } = props;
  const [type, handleChangeType] = useDateFilterType({
    onChange,
    operator,
    value,
  });

  const handleChange = date => {
    const formattedDate = dayjs(date);
    const newValue = !formattedDate || !formattedDate.isValid() ? null : new Date(formattedDate);

    if (onChange && typeof onChange === 'function') {
      onChange({}, newValue ? [newValue.getTime()] : []);
    }
  };

  const [firstValue] = value ?? [];

  return (
    <>
      <DateOptions name="dateOptions" onChange={handleChangeType} value={type} margin={margin} />
      {operator === 'between' && type === 'date' && (
        <DateBetweenFilter
          {...props}
          value={value}
          onChange={onChange}
          operator={operator}
          settings={settings}
          suggestions={suggestions}
        />
      )}
      {(type === 'relative' || type === 'relativeNow') && (
        <RelativeDateFilter
          {...props}
          value={value}
          onChange={onChange}
          operator={operator}
          settings={{
            ...(settings ?? {}),
            relativeNow: type === 'relativeNow',
            showTime: false,
          }}
          suggestions={suggestions}
        />
      )}
      {operator !== 'between' && type === 'date' && (
        <DatePicker
          {...props}
          value={firstValue ?? null}
          onChange={handleChange}
          disableFuture={false}
        />
      )}
    </>
  );
};

DateFilter.propTypes = {
  margin: PropTypes.string,
  onChange: PropTypes.func,
  operator: PropTypes.string,
  settings: PropTypes.object,
  suggestions: PropTypes.array,
  value: PropTypes.array,
};

DateFilter.defaultProps = {
  margin: undefined,
  onChange: undefined,
  operator: undefined,
  settings: {},
  suggestions: [],
  value: [],
};

export default DateFilter;
